const About = () => (			
  <>
			<div id="page-title" className="page-title">
				<div className="container">
					<div className="clearfix">
						<div className="grid_12 mobile-nomargin">
							<div className="page-title-holder">
								<h1>About Ron Wilson Interiors</h1>
							</div>

							<ul className="breadcrumbs">
								<li><a href="index.html">Home</a></li>
								<li>About</li>
							</ul>

						</div>
					</div>
				</div>
			</div>

  <div id="content-wrapper" className="content-wrapper">
    <div className="container">
      <div className="clearfix">


        <div className="grid_6">



							<div className="flexslider flexslider__nav-on">
            <ul className="slides">
              <li>
                <img src="images/sliders/RWI_1.jpg" height="462" width="315" alt="" />
							    </li>
                <li>
                  <img src="images/sliders/RWI_2.jpg" height="462" width="315" alt="" />
							    </li>
                  <li>
                    <img src="images/sliders/RWI_3.jpg" height="462" width="315" alt="" />
							    </li>
							  </ul>
							</div>

						</div>
              <div className="grid_6">
                <h3>Ron Wilson Interiors</h3>
                <p>Ron Wilson Interiors is one of the country’s foremost interior design firms. Founded in 1965 by Ron Wilson, who was often referred to as the ‘Designer to the Stars.’ Ron Wilson Interiors has not only embraced the contemporary California aesthetic of natural and organic material but neutral palettes serving as chic back drops for colorful – sometimes whimsical – art and accessories. Ron Wilson Interiors is now led by Joe Guidera who developed his design aesthetic from the ten years of working and living with Ron Wilson. Beautiful antiques along with richly textured fabrics and surfaces are often the language spoken by Joe Guidera. Joe Guidera has refined Ron Wilson’s aesthetic to carry on his legacy.</p>
              </div>
					</div>

            <div className="hr"></div>


					<div className="clearfix">
              <div className="grid_12">
                <h3>Who We Are</h3>
              </div>
            </div>

            <div className="team-holder clearfix">
              <div className="item-team grid_4">
                <figure className="thumb">
                  <img src="images/joe-guidera.jpg" height="200" width="280" alt="" />
							</figure>
                  <hgroup>
                    <h4>Joe Guidera</h4>
                    <h5>Chief Executive Officer / CEO</h5>
                  </hgroup>
                  <div className="team-excerpt"></div>
                  <footer className="team-footer">

							</footer>
						</div>

              </div>


					<div className="hr"></div>



            </div>
          </div>
</>
);

export default About;
